export default "__VITE_ASSET__h8c4iV50__"